import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

// Phone-only hint that more controls sit below the landing screen; fades once the user scrolls.
export const ScrollHint = ({ hidden, mode }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const check = () => {
      const more = document.documentElement.scrollHeight - window.innerHeight - window.scrollY;
      setShow(window.scrollY < 40 && more > 20);
    };
    check();
    const t = setTimeout(check, 600);
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    return () => {
      clearTimeout(t);
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, [mode]);
  return (
    <button
      data-testid="scroll-hint"
      aria-label="Scroll down for more controls"
      onClick={() => window.scrollBy({ top: window.innerHeight * 0.6, behavior: "smooth" })}
      className={`fixed bottom-[max(0.75rem,env(safe-area-inset-bottom))] right-3 z-40 flex items-center justify-center rounded-full border border-cyan-300/30 bg-slate-950/85 p-1.5 text-cyan-200 shadow-[0_0_18px_rgba(103,232,249,0.25)] backdrop-blur-md transition-opacity duration-500 sm:hidden ${show && !hidden ? "opacity-100" : "pointer-events-none opacity-0"}`}
    >
      <ChevronDown size={20} className="scroll-hint-bounce" />
    </button>
  );
};
